"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.includes.js");
var _react = _interopRequireDefault(require("react"));
var _checkStatusTagGreen = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/check-status-tag-green.svg"));
var _warningStatusTagRed = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/warning-status-tag-red.svg"));
var _clockStatusTagOrange = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/clock-status-tag-orange.svg"));
var _chevronDownStatusTagBlue = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-down-status-tag-blue.svg"));
var _pencilStatusTagGray = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/pencil-status-tag-gray.svg"));
var _ovalStatusTagRed = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/oval-status-tag-red.svg"));
var _ovalStatusTagOrange = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/oval-status-tag-orange.svg"));
var _ovalStatusTagBlue = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/oval-status-tag-blue.svg"));
var _ovalStatusTagGreen = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/oval-status-tag-green.svg"));
var _ovalTagGreen = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/oval-tag-green.svg"));
var _ovalTagOrange = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/oval-tag-orange.svg"));
var _ovalTagRed = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/oval-tag-red.svg"));
var _ovalTagBlack = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/oval-tag-black.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
* Global components
* By Juan Rodrigo <jponceflores@svb.com> (www.svb.com)
* Summary
* This component renders a SVB tags
*/

/**
* SVBTags
* @param {string} [type = 'tag'] - 'tag' || 'pending-tag' || 'status-tag' || 'anatomy-tag'
* @param {string} [size = 'small'] - 'small' || 'large'
* @param {string} [style = 'success'] - 'success' || 'warning' || 'error' || 'info' || 'dark' || 'light' || 'critical' || 'draft' || 'top' || 'bottom'
* @param {string} [icon = 'circle'] - 'check' || 'exclamation' || 'clock' || 'down' || 'pencil' || 'circle'
* @param {string} [text = 'Tag'] - Text to be displayed in the tag
* @param {string} [extraClasses = ''] - Extra classes to be added to the table tag
* @returns JSX element
*/

const SVBTags = props => {
  const getSizeClass = (type, size) => {
    const allowedSizes = ['small', 'large'];
    return type === 'status-tag' && allowedSizes.includes(size) ? "svb-tag_status-tag_".concat(size) : '';
  };
  const getStyleClass = (type, style) => {
    const tagStyles = ['success', 'warning', 'error', 'info'];
    const pendingTagStyles = ['dark', 'light'];
    const statusTagStyles = ['success', 'critical', 'warning', 'info', 'draft'];
    const anatomyTagStyles = ['top', 'bottom'];
    if (type === 'tag') return "svb-tag_".concat(tagStyles.includes(style) ? style : 'success');
    if (type === 'pending-tag') return "svb-tag_".concat(pendingTagStyles.includes(style) ? style : 'light');
    if (type === 'status-tag') return "svb-tag_status-tag_".concat(statusTagStyles.includes(style) ? style : 'success');
    return "svb-tag_anatomy-tag_".concat(anatomyTagStyles.includes(style) ? style : 'top'); //if (type === 'anatomy-tag')
  };

  const getIconSource = (icon, styleClass) => {
    if (icon === 'check') return _checkStatusTagGreen.default;
    if (icon === 'exclamation') return _warningStatusTagRed.default;
    if (icon === 'clock') return _clockStatusTagOrange.default;
    if (icon === 'down') return _chevronDownStatusTagBlue.default;
    if (icon === 'pencil') return _pencilStatusTagGray.default;else {
      if (styleClass === 'svb-tag_status-tag_critical') return _ovalStatusTagRed.default;
      if (styleClass === 'svb-tag_status-tag_warning') return _ovalStatusTagOrange.default;
      if (styleClass === 'svb-tag_status-tag_info') return _ovalStatusTagBlue.default;
      if (styleClass === 'svb-tag_status-tag_success') return _ovalStatusTagGreen.default;
      if (styleClass === 'svb-tag_warning') return _ovalTagOrange.default;
      if (styleClass === 'svb-tag_error') return _ovalTagRed.default;
      if (styleClass === 'svb-tag_info') return _ovalTagBlack.default;else return _ovalTagGreen.default;
    }
  };
  const getIcon = (type, icon, styleClass, sizeClass) => {
    if (type === 'pending-tag' || type === 'anatomy-tag') return;
    const nonDefaultIcons = ['check', 'exclamation', 'clock', 'down', 'pencil'];
    return /*#__PURE__*/_react.default.createElement("img", {
      className: "".concat(sizeClass === 'svb-tag_status-tag_small' && nonDefaultIcons.includes(icon) ? 'svb-tag_status-tag-icon_small' : ''),
      src: getIconSource(icon, styleClass)
    });
  };
  const allowedTypes = ['tag', 'pending-tag', 'status-tag', 'anatomy-tag'];
  const type = allowedTypes.includes(props.type) ? props.type : 'tag';
  const sizeClass = getSizeClass(type, props.size);
  const styleClass = getStyleClass(type, props.style);
  const icon = getIcon(type, props.icon, styleClass, sizeClass);
  const text = props.text || 'Tag';
  const extraClasses = props.extraClasses || '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-tag svb-tag_".concat(type, " ").concat(sizeClass, " ").concat(styleClass, " ").concat(extraClasses)
  }, icon, type === 'anatomy-tag' && styleClass === 'svb-tag_anatomy-tag_bottom' && /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("p", null, text), type === 'anatomy-tag' && styleClass === 'svb-tag_anatomy-tag_top' && /*#__PURE__*/_react.default.createElement("div", null));
};
var _default = SVBTags;
exports.default = _default;